import { useAssignSetting } from "./__internal__/useSetting";
import { OWF_TERMS_INCREASE_250307 } from "@faire/web-api--source/indigofair/settings/OWF_TERMS_INCREASE_250307";

export const useAssignOwfTermsIncrease = () =>
  useAssignSetting(OWF_TERMS_INCREASE_250307);
